import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from 'services/api'
import { toast } from 'react-toastify'

export function useGetProgressInfo(courseId: string, modulesRef: string[]) {
  const token = localStorage.getItem('token')

  const url = `/course/get-progress-info`

  const key = token ? [url, token, courseId, modulesRef] : null

  return useSWR(key, fetcher, configuration)
}

const fetcher = ([url, token, courseId, modulesRef]: [string, string, string, string[]]) =>
  learningApi
    .post(
      url,
      {
        product: courseId,
        modulesRef,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then((res) => res.data)

const configuration: SWRConfiguration = {
  fallbackData: [],
  shouldRetryOnError: true,
  onErrorRetry: (error, key, config, revalidate, { retryCount }) => {
    if (retryCount > 3) {
      toast.error('Não foi possível carregar os módulos do curso. Tente novamente mais tarde.')
    } else {
      setTimeout(() => revalidate({ retryCount }), 1000)
    }
  },
  keepPreviousData: true,
  dedupingInterval: 60e3,
  revalidateOnReconnect: true,
}
